export function camelToText(camelStr: string) {
  // Insert space before capital letters and capitalize first letter
  return camelStr
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
}

/**
 * Extracts a user-friendly error message from an axios/fetch/firebase error.
 * Falls back to a generic message when nothing useful is available.
 */
export function getErrorMessage(
  error: any,
  fallbackMessage = "Something went wrong. Please try again."
): string {
  if (!error) return fallbackMessage;

  const backendMessage =
    error?.response?.data?.message ??
    error?.data?.message ??
    error?.response?.data?.error ??
    error?.message;

  if (typeof backendMessage === "string" && backendMessage.trim()) {
    if (backendMessage === "Network Error") {
      return "Network error. Please check your internet connection and try again.";
    }
    return backendMessage;
  }

  return fallbackMessage;
}
